import React, { useState, useEffect } from 'react';
import './InterviewSchedule.css';

const ResumeDetails = ({ applicant }) => {

    return (
        <div className="resume-container">
              <div className="resume-header">
                <div className="header-content">
                  <div className="personal-info">
                    <h1 className="name">{applicant.user_names}</h1>
                    <h2 className="title">{applicant.job_title}</h2>
                  </div>
                  <div className="profile-avatar">
                    <img src={`${process.env.REACT_APP_API_URL}/profile/get-pic/${encodeURIComponent(applicant.user_id)}`} alt={applicant.user_names} />
                  </div>
                </div>
              </div>
        
              <div className="resume-body">
                <div className="main-content">
                  <section className="experience-section">
                    <h3 className="section-title">EXPERIENCE</h3>
                    <div className="experience-list">
                      {applicant.work_experience.map(exp => (
                        <div key={exp.id} className="experience-item">
                          <div className="job-header">
                            <h4 className="job-title">{exp.job_title}</h4>
                            <p className="company-name">{exp.company_name}</p>
                            <p className="job-period">{exp.start_date}</p>
                          </div>
                          <p className="job-description">{exp.description}</p>
                        </div>
                      ))}
                    </div>
                  </section>
        
                  <section className="education-section">
                    <h3 className="section-title">EDUCATION</h3>
                    <div className="education-list">
                      {applicant.education.map(edu => (
                        <div key={edu.id} className="education-item">
                          <h4 className="degree-title">{edu.field_of_study}</h4>
                          <p className="school-name">{edu.institution}</p>
                          <p className="education-period">{edu.start_date}</p>
                        </div>
                      ))}
                    </div>
                  </section>
                </div>
        
                <div className="sidebar">
                  <div className="contact-info">
                    <p className="contact-item">{applicant.user_email}</p>
                    <p className="contact-item">{applicant.user_phone_number}</p>
                    {/* <p className="contact-item">{data.personalInfo.location}</p> */}
                  </div>
        
                  <section className="skills-section">
                    <h3 className="sidebar-title">Industry Knowledge</h3>
                    <div className="skills-list">
                      {applicant.skills.map((skill, index) => (
                        <p key={index} className="skill-item">{skill.name}</p>
                      ))}
                    </div>
                  </section>
        
                  {/* <section className="tools-section">
                    <h3 className="sidebar-title">Tools & Technologies</h3>
                    <div className="tools-list">
                      <p className="tools-text">
                        {data.toolsTech.join(', ')}
                      </p>
                    </div>
                  </section>
        
                  <section className="other-skills-section">
                    <h3 className="sidebar-title">Other Skills</h3>
                    <div className="other-skills-list">
                      <p className="other-skills-text">
                        {data.otherSkills.join(', ')}
                      </p>
                    </div>
                  </section> */}
        
                  <section className="languages-section">
                    <h3 className="sidebar-title">Languages</h3>
                    <div className="languages-list">
                      {applicant.languages.map((language, index) => (
                        <p key={index} className="language-item">{language.name}</p>
                      ))}
                    </div>
                  </section>
        
                  {/* <section className="social-section">
                    <h3 className="sidebar-title">Social</h3>
                    <div className="social-list">
                      {data.social.map((social, index) => (
                        <p key={index} className="social-item">{social}</p>
                      ))}
                    </div>
                  </section> */}
                </div>
              </div>
              </div>
    );
};
export default ResumeDetails;